import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import '../../assets/css/locations.scss';
import CONSTANTS from '../../constants';
import ImageHelper from '../../helpers/ImageHelper';
import OrderTypeHelper from '../../helpers/OrderTypeHelper';
import AnalyticsService from '../../services/AnalyticsService';
import CartService from '../../services/CartService';
import OutletsList from './OutletsList';

class RouteModal extends Component {
  constructor(props) {
    super(props);
    const current_time = new Date();
    let outlet = props._outlets ? props._outlets[0] : '';
    // const cartState = CartService.getOrderData(
    //   this.props.location?.orderTypes,
    //   this.props.location
    // );
    // let order_type = props?.location?.orderTypes.filter(
    //   (ot) => ot.order_type === cartState.order_type_id
    // );
    // if (order_type.length === 0) {
    //   order_type = props.location.orderTypes[0];
    // } else {
    //   order_type = order_type[0];
    // }
    const allowedOrderTypes = {};
    for (let i = 0; i < props._outlets.length; i++) {
      const out = props._outlets[i];
      for (let j = 0; j < out.orderTypes.length; j++) {
        allowedOrderTypes[out.orderTypes[j].order_type] = true;
        if (out.orderTypes[j].order_type === CONSTANTS.ORDERS.VARIABLES.ORDER_TYPES.DELIVERY) {
          if (outlet.loc_id === props.location.loc_id) continue;
          outlet = out;
        }
      }
    }
    this.state = {
      allowedOrderTypes,
      cartState: {
        errors: [],
        showErrors: false,
        showMapModal: false,
        showTimePickerModal: false,
        showOutlets: false,
        showSavedLocations: false,
        current_time,
        delivery_phone: '',
        delivery_location: '',
        delivery_address: '',
        car_number: '',
        car_model: '',
        comment: '',
        order_type_id: null,
        order_time: current_time,
        order_date: CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY,
        isPickUpNow: true,
        selectedOutlet: outlet,
        isTakeAwayAvail: false,
        selectedLocation: '',
        editLocation: '',
        itemIndex: '',
        showAlerModal: false,
        savedLocations: [],
        deliveryOutletError: false
      },
      order_type: '',
      order_type_id: null,
      errors: '',
      isOutletSelected: false,
      geoLocation: this.props.geoLocation ? this.props.geoLocation : '',
      loadingCode: false
    };
  }

  async componentDidMount() {
    let cartState = CartService.getOrderData(this.props.location.orderTypes, this.props.location);
    if (!cartState || !cartState.selectedOutlet) {
      cartState = this.state.cartState;
    }
    if (!cartState.order_type_id) {
      cartState.order_type_id = this.props.location.orderTypes[0].id;
    }
    await this.setState({ cartState, order_type_id: cartState.order_type_id });
    CartService.setOrderData(
      this.state.cartState,
      this.props.location.orderTypes,
      this.props.location
    );
    this.props.updateMenu(false, false);
    if (navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state === 'granted') {
          navigator.geolocation.getCurrentPosition(
            this.onGeoLocationSuccess.bind(this),
            this.onGeoLocationError.bind(this),
            {
              enableHighAccuracy: true,
              timeout: CONSTANTS.SETTINGS.LOCATION_TIMEOUT
            }
          );
        } else if (result.state === 'prompt') {
        } else if (result.state === 'denied') {
        }
      });
    }
  }

  onGeoLocationSuccess(position) {
    let geoLocation = `${position.coords.latitude},${position.coords.longitude}`;
    this.setState({ geoLocation });
  }

  onGeoLocationError() {
    alert('Plugd needs your device location for outlets distance. Please enable your GPS.');
  }

  changeOrderType(type) {
    if (this.props.showModal && !this.state.loadingCode) {
      const cartState = JSON.parse(JSON.stringify(this.state.cartState));
      cartState.order_type_id = type.id;
      this.setState({ order_type_id: type.id, order_type: type, cartState });
    }
  }

  updateState(cartState) {
    this.setState({ cartState, isOutletSelected: true });
  }

  renderOrderTypeOptions(orderTypes) {
    return orderTypes
      .filter((ot) => this.state.allowedOrderTypes[ot.order_type])
      .map((orderType) => {
        return (
          <div key={orderType.id} className="input-container input-container-modal order-type">
            <input
              checked={orderType.id === this.state.order_type_id}
              value={orderType.id}
              id={orderType.order_type}
              className="radio-button"
              type="radio"
              name="order_type_id"
              onChange={this.changeOrderType.bind(this, orderType)}
            />
            <div className="radio-tile modal-radio-tile">
              <label htmlFor={orderType.order_type} className="radio-tile-label">
                {orderType.label}
              </label>
            </div>
          </div>
        );
      });
  }

  updateCartData() {
    this.setState({ loadingCode: true });
    setTimeout(() => {
      this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.OUTLET_SELECTED);
      CartService.setOrderData(
        this.state.cartState,
        this.props.location.orderTypes,
        this.props.location
      );
      this.props.updateMenu(false, true);
    }, 1);
  }


  firebaseEvent(eventName) {
    AnalyticsService.logEvent(eventName, {
      event: eventName
    });
    AnalyticsService.logRestaurantEvent(this.props.location.anaytics_code, {
      event: eventName
    })
  }

  render() {
    const { location: _location, _outlets } = this.props;
    const sortedTypes = OrderTypeHelper.sortOrderTypes(_location.orderTypes);
    const getFirstChar = (str) => {
      const firstChars = str
        .split(' ')
        .map((word) => word[0])
        .join('');

      return firstChars;
    };
    const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
    if (_location && _outlets) {
      return (
        <React.Fragment>
          <Modal
            isOpen={this.props.showModal}
            toggle={this.props.toggleModal}
            backdrop='static'
            className="modal route-pref-modal"
            onClosed={this.props.closeModal}
          >
            {/* {closeBtn} */}

            <div className="modal-header no-border header-margin-top d-flex justify-content-center">
              <h5 className="modal-title text-bold">&nbsp;</h5>
              <div className="d-block mb-2 ml-1" >
                {this.props.settings && this.props.settings.logo && (
                  <img
                    src={ImageHelper.getImageURL(
                      this.props.settings.logo,
                      '?func=cover'
                    )}
                    className="route-img-bg rounded-circle border border-5"
                    alt={this.props.location.name}
                    style={{ width: '120px', height: '120px' }}
                  ></img>
                )}
                {!this.props.settings.logo && (
                  <div class="i-circle border border-5">
                    {getFirstChar(this.props.location.name)}
                  </div>
                )}
              </div>

            </div>
            <ModalBody className="background-skin route-background-skin primary-color">
              <div className='card-color' style={{ height: '55px' }}></div>
              <div className="card flex-md-row box-shadow h-md-250 p-3 no-border route-order-type-padding-top primary-color card-color rounded-0">
                <div className="row row-width">
                  <div className="col-lg-12 order-types " id="order_type_id">
                    <div className="radio-container" id="minimum_order">
                      <div className="radio-tile-group">
                        {this.renderOrderTypeOptions(sortedTypes)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <OutletsList
                cartState={this.state.cartState}
                geoLocation={this.state.geoLocation}
                outlets={OrderTypeHelper.pickOutletsFor(
                  sortedTypes,
                  this.state.order_type_id,
                  _outlets
                )}
                updateState={this.updateState.bind(this)}
              />
            </ModalBody>
            <ModalFooter className="background-skin primary-color">
              <div className="container-fluid">
                <div className="row">
                  {this.state.isOutletSelected && (
                    <Button
                      className={`col-lg-12 btn btn-primary btn-lg ${branding_btn}`}
                      onClick={this.updateCartData.bind(this)}
                    >
                      {this.state.loadingCode ? (
                        <div className="text-sm spinner-border primary-font-color ml-2" role="status" style={{ marginBottom: '-5px' }}>
                          <span className="sr-only"></span>
                        </div>
                      ) : 'Done'}
                    </Button>
                  )}


                </div>
              </div>
            </ModalFooter>

          </Modal>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}
function mapStateToProps(state) {
  const { location, childLocations } = state;
  return { _location: location, _outlets: childLocations };
}
export default connect(mapStateToProps)(RouteModal);
